import { defineMessages } from 'react-intl'

export const challengeMessages = defineMessages({
  participants: {
    id: 'challengeMessages.participants',
    defaultMessage: 'Participants'
  },
  firstName: {
    id: 'challengeMessages.firstName',
    defaultMessage: 'First name'
  },
  lastName: {
    id: 'challengeMessages.lastName',
    defaultMessage: 'Last name'
  },
  csvDisclaimer: {
    id: 'ChallengeParticipants.csvDisclaimer',
    defaultMessage: 'IMPORTANT: Participant contact information can only be used to communicate information related to the Challenge. Names and email addresses should not be shared with any third-party organizations without the express consent of participants.'
  },
  understand: {
    id: 'ChallengeParticipants.understand',
    defaultMessage: 'Yes, I understand'
  }
})
